import React, { forwardRef } from "react";
import { cx } from "../../utils";
import { ButtonProps, ButtonLinkProps, ButtonStyleProps } from "./Button.types";
export type { ButtonProps, ButtonLinkProps } from "./Button.types";

const variants = {
  primary: "border border-primary bg-primary text-white hover:bg-primary-hover",
  secondary: "border-0 bg-control text-control-foreground",
  outline: "border border-border-action bg-transparent text-action hover:bg-surface-hover",
  overlay: "border border-border-strong bg-overlay-action/[.38] text-white hover:bg-white/[.13]",
  subtle: "bg-player-raised hover:bg-player-border",
  ghost: "",
};
const sizes = {
  sm: "inline-flex items-center justify-center gap-2 rounded px-3 py-2",
  md: "inline-flex items-center justify-center gap-3 rounded-lg px-[14px] py-[11px] text-form-input font-semibold",
  action: "inline-flex items-center justify-between gap-[26px] px-5 py-[15px] text-eyebrow font-black tracking-[.15em] transition-[background,transform] duration-200 hover:-translate-y-0.5 max-[640px]:gap-2.5 max-[640px]:px-3 max-[640px]:py-[13px] max-[640px]:text-[9px]",
  detail: "flex gap-3 px-[18px] py-[15px] text-caption font-extrabold tracking-[.17em] transition-[background] duration-200",
  none: "",
};
export function buttonStyles({ variant = "primary", size = "md", fullWidth, className }: ButtonStyleProps = {}) {
  return cx("motion-reduce:transition-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-focus disabled:cursor-not-allowed disabled:opacity-45", variants[variant], sizes[size], fullWidth && "w-full", className);
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant, size, fullWidth, className, type = "button", ...props }, ref,
) {
  return <button ref={ref} type={type} className={buttonStyles({ variant, size, fullWidth, className })} {...props} />;
});

export const ButtonLink = forwardRef<HTMLAnchorElement, ButtonLinkProps>(function ButtonLink(
  { variant, size, fullWidth, className, children, ...props }, ref,
) {
  return <a ref={ref} className={buttonStyles({ variant, size, fullWidth, className })} {...props}>{children}</a>;
});
